import React from "react";
import styles from "./_css/propertiesSearchBar.module.css";
import clsx from "clsx";
import { Filters } from "properties/searchBar/Filters";
import { useTranslation } from "react-i18next";
import { panelStore } from "main/header/panel/_stores/panelStore";
import { MobileFilters } from "properties/searchBar/MobileFilters";
import { usePropertiesStore } from "properties/listing/PropertiesPageContext";
import { useMap, useScrollPositionAlt } from "_common/_utils/hookUtils";
import { PROPERTY_PURPOSE } from "properties/_models/PropertyMdl";
import { FILTER_KEYS } from "properties/searchBar/filters/_utils/filtersUtils";
import { SearchBarGeoZoneAndProperties } from "properties/searchBar/SearchBarGeoZoneAndProperties";
import { geoZonesStore } from "geoZones/_stores/geoZonesStore";
import { UiButton } from "_common/ui/mui/buttons/UiButton";
import { KeyboardArrowDown } from "@material-ui/icons";
import { SwitchButtonMapList } from "properties/SwitchButtonMapList";

export default function PropertiesSearchBar() {
    const propertiesStore = usePropertiesStore();
    const listStore = propertiesStore.getListStore(propertiesStore.purpose);
    const { t } = useTranslation();
    const propertyType = listStore.filters.find((filter) => filter.id === FILTER_KEYS.TYPE)?.value?.[0];
    const { isLoaded } = useMap();
    const scrollPosition = useScrollPositionAlt();

    return (
        <div
            className={clsx(styles.container, "ph_20 flex_row_center position_relative gap_20", {
                [styles.scrolled]: scrollPosition,
            })}
        >
            <div
                className={clsx(styles.searchInput)}
                onClick={() => {
                    geoZonesStore.open(false);
                }}
            >
                {isLoaded && (
                    <SearchBarGeoZoneAndProperties
                        purpose={propertiesStore.purpose ?? PROPERTY_PURPOSE.BUY}
                        propertyType={propertyType}
                    />
                )}
            </div>
            <div id="propertiesSearchBar_filters" className={clsx(styles.filters)}>
                <Filters />
            </div>
            <UiButton
                className={clsx(styles.mobileFilters, "flex_row_center cursor_pointer")}
                variant={"outlined"}
                color={"primary"}
                onClick={() => {
                    panelStore.open({
                        full: true,
                        title: t("words.filters"),
                        children: <MobileFilters listStore={listStore} propertiesStore={propertiesStore} />,
                        onClose: () => panelStore.close(),
                        withSpinner: false,
                        opened: true,
                    });
                }}
            >
                {t("words.filters")} <KeyboardArrowDown className={"ml_5"} fontSize={"large"} />
            </UiButton>
            <div className={"flex-1"} />
            <SwitchButtonMapList />
        </div>
    );
}
